import * as S from './input-error.styles'

interface IInputErrorProps {
  error?: string
}

const InputError = ({ error }: IInputErrorProps): JSX.Element | null => {
  return (
    <S.TextAreaErrorWrapper>
      <S.ErrorIcon />
      <S.ErrorTypography variant="h5">{error}</S.ErrorTypography>
    </S.TextAreaErrorWrapper>
  )
}

export { InputError }
